let dd = require('ES/lib/dd');
let Modal = require('ES/widgets/Modal');
let esUtils = require('ES/utils/esUtils');
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");


module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {show_confirmed_message: null};
  },

  __close: esUtils.wrapPreventDefault(function () {
    this.setState({show_confirmed_message: null});
  }),
  Radio_setup() {
    return {
      PromptWhenEventConfirmed(event) {
        this.setState({show_confirmed_message: event});
      }
    };
  },
  render() {
    if (!this.state.show_confirmed_message) {
      return null;
    }
    return Modal({
        title: "Confirmed Event",
        buttons: [],
        onClose: this.__close
      },
      dd.div({className: 'row'},
        dd.div({className: 'col-sm-3 text-center text-muted'},
          dd.i({className: 'fa fa-check-circle-o', style: {fontSize: 115}})
        ),
        dd.div({className: 'col-sm-9'},
          dd.p({}, "Don't forget to set the CONTRACT EXECUTION DATE on the MISC tab."),
          dd.button({className: 'btn-primary btn', onClick: this.__close}, 'I Definitely Will Not')
        )
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/modals/PromptWhenEventConfirmed.js